/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


import {UserDetailsRes} from './user.contract';
import {UserRoleRes} from '@yasc/yasc-material-components';

export class AccountCollectionRes {
    data!: UserDetailsRes[];
    entries!: number;
}

export class AccountConfirmRes {
    success!: boolean;
    token!: string;
    errors: string[] = []
    user!: UserDetailsRes
    confirmToken!: string
}


export class RoleCollectionRes {
    roles: UserRoleRes[] = [];
    permissions: string[] = []


    isSuperAdmin(): boolean {
        return this.roles.map(x => x.name).includes('SuperAdmin');
    }

    isAdmin(): boolean {
        return this.roles.map(x => x.name).includes('Admin') || this.isSuperAdmin();
    }

    isUser(): boolean {
        return this.roles.map(x => x.name).includes('User') || this.isAdmin();
    }
}

export class PermissionReq {
    id!: number;
    availableForRoles!: number[];
}

export class PermissionRes {
    id!: number;
    name!: string
    nameFormatted!: string;
    actionBase!: string;
    actionBaseFormatted!: string;
    actionName!: string;
    description!: string
    availableForRoles: number[] = [];
    isModule!: boolean;

    // TODO: allow dynamic columns, only workaround for table
    get yascAllowed() {
        return this._isIncluded(1);
    };

    set yascAllowed(value: boolean) {
        this._update(1, value);
    };

    get adminAllowed() {
        return this._isIncluded(2);
    };

    set adminAllowed(value: boolean) {
        this._update(2, value);
    };

    get projectManagerAllowed() {
        return this._isIncluded(3);
    };

    set projectManagerAllowed(value: boolean) {
        this._update(3, value);
    };

    get userAllowed() {
        return this._isIncluded(4);
    };

    set userAllowed(value: boolean) {
        this._update(4, value);
    };

    get hrAllowed() {
        return this._isIncluded(5);
    };

    set hrAllowed(value: boolean) {
        this._update(5, value);
    };

    get bookkeeperAllowed() {
        return this._isIncluded(6);
    };

    set bookkeeperAllowed(value: boolean) {
        this._update(6, value);
    };

    get financierAllowed() {
        return this._isIncluded(7);
    };

    set financierAllowed(value: boolean) {
        this._update(7, value);
    };

    get orderAndLicensingAllowed() {
        return this._isIncluded(8);
    };

    set orderAndLicensingAllowed(value: boolean) {
        this._update(8, value);
    };

    get inventoryManagerAllowed() {
        return this._isIncluded(9);
    };

    set inventoryManagerAllowed(value: boolean) {
        this._update(9, value);
    };

    get productManagerAllowed() {
        return this._isIncluded(10);
    };

    set productManagerAllowed(value: boolean) {
        this._update(10, value);
    };

    get acquisitionAllowed() {
        return this._isIncluded(11);
    };

    set acquisitionAllowed(value: boolean) {
        this._update(11, value);
    };


    _isIncluded(id: number): boolean {
        return this.availableForRoles.includes(id)
    }

    _update(id: number, value: boolean) {
        if (value)
            this.availableForRoles.push(id)
        else
            this.availableForRoles = this.availableForRoles.filter(role => role !== id)
    }
}

export class ForgotPasswordReq {
    email!: string;

}

export class ForgotPasswordConfirmReq {
    password!: string;
    passwordConfirm!: string;
    token!: string;
    email!: string;
}